/**
 * Search and Voice Routing Directory for Select-ezi Marketplaces
 * Maps natural speech and typed search terms to the appropriate marketplace routes.
 */

export const CATEGORY_ROUTES = [
  {
    name: "Food & Restaurant",
    route: "/BuyRestaurantFood",
    icon: "🍔",
    description: "Restaurants, cafes, food items, drinks & meals",
    keywords: [
      "food", "restaurant", "dining", "menu", "cafe", "eat", "meal", "dishes",
      "burger", "pizza", "biryani", "lunch", "dinner", "breakfast", "roti",
      "fast food", "drinks", "beverage", "cook", "bakery", "sweets", "chai",
      "tea", "coffee", "shawarma", "sandwich", "bbq", "tikka", "kebab", "rice"
    ],
  },
  {
    name: "Vehicle Markets",
    route: "/buy-used-cars",
    icon: "🚗",
    description: "Used cars, bikes, motors & automobiles",
    keywords: [
      "car", "cars", "vehicle", "vehicles", "motor", "bike", "bikes", "motorcycle",
      "auto", "automobile", "used car", "used vehicle", "van", "jeep", "suv",
      "toyota", "honda", "suzuki", "sedan", "hatchback", "scooter", "civic", "corolla"
    ],
  },
  {
    name: "Real Estate & Properties",
    route: "/find-property",
    icon: "🏠",
    description: "Houses, plots, flats, apartments & commercial real estate",
    keywords: [
      "property", "properties", "real estate", "house", "plot", "plots", "land",
      "flat", "flats", "apartment", "apartments", "building", "commercial",
      "housing", "estate", "plaza", "villa", "rent property", "buy house"
    ],
  },
  {
    name: "Retailer Markets",
    route: "/buy-retailer",
    icon: "🛍️",
    description: "Retail shops, shoes, clothing, electronics & everyday items",
    keywords: [
      "retail", "retailer", "retailers", "grocery", "groceries", "household",
      "cloth", "clothes", "clothing", "fashion", "apparel", "store", "general store",
      "shoes", "shoe", "footwear", "cosmetics", "daily use", "watch", "watches",
      "mobile", "phone", "electronics", "laptop", "perfume", "accessories",
      "makeup", "bag", "bags", "shirt", "pant", "dress", "shopping", "goods"
    ],
  },
  {
    name: "Wholesale Markets",
    route: "/buy-wholeseller",
    icon: "📦",
    description: "Bulk supply, wholesale goods & B2B distributors",
    keywords: [
      "wholesale", "wholesaler", "wholesalers", "wholeseller", "bulk", "bulk order",
      "distributor", "distributors", "wholesale market", "b2b supply", "bulk supply"
    ],
  },
  {
    name: "Industrial & Manufacturing",
    route: "/buy-manufacturer",
    icon: "🏭",
    description: "Factories, industrial plants, machinery & production",
    keywords: [
      "manufacturer", "manufacturers", "factory", "factories", "industry", "industrial",
      "manufacturing", "plants", "machinery", "heavy equipment", "industrial tools"
    ],
  },
  {
    name: "Raw Material Markets",
    route: "/buy-raw-material",
    icon: "⛏️",
    description: "Mining, steel, iron, ore, metal, timber & raw minerals",
    keywords: [
      "raw material", "raw materials", "mining", "iron", "steel", "ore",
      "metal", "timber", "wood", "minerals raw", "copper", "aluminum", "raw"
    ],
  },
  {
    name: "Gems & Jewelry",
    route: "/buy-Minerals",
    icon: "💎",
    description: "Gold, silver, diamond, gemstones & precious minerals",
    keywords: [
      "gem", "gems", "jewelry", "jewellery", "gold", "silver", "diamond",
      "gemstone", "gemstones", "precious stone", "mineral", "minerals", "necklace", "ring", "bangles"
    ],
  },
  {
    name: "2nd Hand / Used Items",
    route: "/buy-used-products",
    icon: "🔄",
    description: "Pre-owned, second-hand goods & affordable used items",
    keywords: [
      "second hand", "2nd hand", "used item", "used items", "used product",
      "used products", "pre-owned", "preowned", "resale", "old items", "used"
    ],
  },
  {
    name: "HomeMade Items",
    route: "/buy-homemade-products",
    icon: "🎨",
    description: "Handicrafts, homemade products & artisanal goods",
    keywords: [
      "homemade", "home made", "home-made", "hand craft", "handicraft",
      "handmade", "hand made", "home goods", "home kitchen", "artisan", "crafts"
    ],
  },
  {
    name: "Available Jobs",
    route: "/find-job",
    icon: "💼",
    description: "Job vacancies, career openings & recruitment offers",
    keywords: [
      "job", "jobs", "hiring", "recruitment", "vacancy", "vacancies",
      "career", "careers", "employment", "work", "find job", "available jobs", "apply job", "urgent hiring"
    ],
  },
  {
    name: "Job Candidates",
    route: "/find-candidates",
    icon: "🧑‍💼",
    description: "Resumes, CVs, talents & job seekers",
    keywords: [
      "candidate", "candidates", "cv", "resume", "applicant", "applicants",
      "hire candidate", "job seekers", "talent", "staff"
    ],
  },
  {
    name: "Transportation & Shipment",
    route: "/find-Transport",
    icon: "🚛",
    description: "Cargo, logistics, delivery trucks, freight & rental vehicles",
    keywords: [
      "transport", "transportation", "shipment", "cargo", "delivery",
      "logistics", "truck", "trucks", "freight", "courier", "moving", "rental vehicle", "htv", "ltv"
    ],
  },
  {
    name: "Services Market",
    route: "/find-services",
    icon: "🔧",
    description: "Contractors, electricians, plumbers, repair & maintenance",
    keywords: [
      "service", "services", "contractor", "contractors", "electrician",
      "plumber", "carpenter", "repair", "maintenance", "technician", "expert", "cleaning", "mechanic"
    ],
  },
  {
    name: "Recycled & Scrap Market",
    route: "/recycle-online",
    icon: "♻️",
    description: "Scrap material, waste recycling, reusable materials & junk",
    keywords: [
      "recycle", "recycled", "recycling", "scrap", "waste", "plastic waste",
      "garbage", "reusable", "scrap material", "junk"
    ],
  },
  {
    name: "Agriculture & Farming",
    route: "/Farming-online",
    icon: "🌾",
    description: "Crops, seeds, fertilizers, farming tools & agriculture",
    keywords: [
      "farm", "farming", "agriculture", "seeds", "seed", "crop", "crops",
      "fertilizer", "fertilizers", "tractor", "farming tools", "harvest", "wheat", "cotton"
    ],
  },
  {
    name: "Single Item For Sale",
    route: "/single-item-buy",
    icon: "🏷️",
    description: "Individual products, single classified ads & personal items",
    keywords: [
      "single item", "single items", "personal item", "individual item",
      "single ad", "single ads", "single product"
    ],
  },
  {
    name: "Personal Property",
    route: "/buy-single-property",
    icon: "🏢",
    description: "Personal properties for rent or direct sale",
    keywords: [
      "personal property", "single property", "rent or sale", "property ad", "for rent"
    ],
  },
];

/**
 * Resolves a search query to the most appropriate marketplace route.
 * Falls back to Retailer Market (/buy-retailer) so any general product search
 * (e.g. shoes, watch, shirt, phone) always searches data instead of returning nothing.
 */
export const resolveSearchRoute = (rawQuery) => {
  if (!rawQuery || typeof rawQuery !== "string") {
    return {
      route: "/buy-retailer",
      name: "Retailer Market",
      query: "",
      isFallback: true,
    };
  }

  const clean = rawQuery.trim().toLowerCase();
  if (!clean) {
    return {
      route: "/buy-retailer",
      name: "Retailer Market",
      query: "",
      isFallback: true,
    };
  }

  const words = clean.split(/\s+/).filter(Boolean);

  let bestMatch = null;
  let bestScore = 0;

  for (const cat of CATEGORY_ROUTES) {
    for (const kw of cat.keywords) {
      const kwLower = kw.toLowerCase();
      // Exact match gets highest score
      if (clean === kwLower) {
        return {
          route: cat.route,
          name: cat.name,
          query: rawQuery.trim(),
          matchedKeyword: kw,
          isExact: true,
        };
      }

      // Word boundary match
      if (words.includes(kwLower)) {
        const score = 100 + kwLower.length;
        if (score > bestScore) {
          bestScore = score;
          bestMatch = {
            route: cat.route,
            name: cat.name,
            query: rawQuery.trim(),
            matchedKeyword: kw,
          };
        }
      } else if (clean.includes(kwLower)) {
        const score = 50 + kwLower.length;
        if (score > bestScore) {
          bestScore = score;
          bestMatch = {
            route: cat.route,
            name: cat.name,
            query: rawQuery.trim(),
            matchedKeyword: kw,
          };
        }
      }
    }
  }

  if (bestMatch) {
    return bestMatch;
  }

  // Fallback: default to Retailer Market so general searches (shoes, milk, mobile, etc.)
  // always query and show results
  return {
    route: "/buy-retailer",
    name: "Retailer Market",
    query: rawQuery.trim(),
    isFallback: true,
  };
};

/**
 * Returns matching categories for autocomplete / suggestions dropdown
 */
export const getCategorySuggestions = (rawQuery, maxResults = 4) => {
  if (!rawQuery || typeof rawQuery !== "string") return [];
  const clean = rawQuery.trim().toLowerCase();
  if (clean.length < 2) return [];

  const matched = [];
  for (const cat of CATEGORY_ROUTES) {
    const kwMatch = cat.keywords.find(
      (kw) => kw.includes(clean) || clean.includes(kw)
    );
    if (kwMatch || cat.name.toLowerCase().includes(clean)) {
      matched.push({
        name: cat.name,
        route: cat.route,
        icon: cat.icon,
        description: cat.description,
        matchedKeyword: kwMatch || cat.name,
      });
      if (matched.length >= maxResults) break;
    }
  }
  return matched;
};

/**
 * Checks if a search/voice query matches any backend marketplace category, keyword, or query.
 * Supports large/long sentences, extracting the exact matching query keyword so backend database
 * queries (regex on dishname, itemname, brand, etc.) successfully find matching records.
 */
export const matchBackendQuery = (rawQuery) => {
  if (!rawQuery || typeof rawQuery !== "string") return null;
  const clean = rawQuery.trim().toLowerCase();
  if (clean.length < 2) return null;

  // 1. Direct / exact keyword matching
  for (const cat of CATEGORY_ROUTES) {
    for (const kw of cat.keywords) {
      const kwLower = kw.toLowerCase();
      if (clean === kwLower) {
        return {
          route: cat.route,
          name: cat.name,
          query: kw,
          matchedKeyword: kw,
          isExact: true,
          isMatch: true,
        };
      }
    }
  }

  // 2. Large sentence / multi-word phrase matching (extract keyword from conversational speech)
  let bestMatch = null;
  let bestScore = 0;

  for (const cat of CATEGORY_ROUTES) {
    const catLower = cat.name.toLowerCase();

    // Check category name match in sentence
    const catRegex = new RegExp(`(^|\\b)${catLower.replace(/[.*+?^${}()|[\\]\\]/g, "\\$&")}(\\b|$)`, "i");
    if (catRegex.test(clean)) {
      const score = 150 + catLower.length;
      if (score > bestScore) {
        bestScore = score;
        bestMatch = {
          route: cat.route,
          name: cat.name,
          query: cat.name,
          matchedKeyword: cat.name,
          fullSpokenText: rawQuery.trim(),
          isMatch: true,
        };
      }
    }

    // Check keyword matches in sentence
    for (const kw of cat.keywords) {
      const kwLower = kw.toLowerCase();
      const kwRegex = new RegExp(`(^|\\b)${kwLower.replace(/[.*+?^${}()|[\\]\\]/g, "\\$&")}(\\b|$)`, "i");
      if (kwRegex.test(clean)) {
        // Multi-word / longer keywords get higher priority (e.g. "used car" > "car")
        const score = 100 + kwLower.length * 2;
        if (score > bestScore) {
          bestScore = score;
          bestMatch = {
            route: cat.route,
            name: cat.name,
            query: kw,
            matchedKeyword: kw,
            fullSpokenText: rawQuery.trim(),
            isMatch: true,
          };
        }
      }
    }
  }

  if (bestMatch) {
    return bestMatch;
  }

  // 3. Fallback partial word match (e.g. "vegetables", "phones", "laptops")
  const words = clean.split(/\s+/).filter((w) => w.length >= 3);
  for (const cat of CATEGORY_ROUTES) {
    for (const kw of cat.keywords) {
      const kwLower = kw.toLowerCase();
      if (words.some((w) => kwLower.includes(w) || w.includes(kwLower))) {
        return {
          route: cat.route,
          name: cat.name,
          query: kw,
          matchedKeyword: kw,
          fullSpokenText: rawQuery.trim(),
          isMatch: true,
        };
      }
    }
  }

  return null;
};


